export interface ArticleItem {
  id: number;
  slug: string;
  title: string;
  category: string;
  categorySlug: string;
  heat: string;
  heatNum: number;
  image: string;
  time: string;
  summary: string;
}

export const categoryConfig: Record<string, { name: string; subtitle: string; description: string }> = {
  'wanghong-tafang': {
    name: '网红塌房',
    subtitle: '实时追踪网红翻车现场',
    description: '聚焦网红圈内最新塌房事件，从千万粉大V到新兴网红，第一时间为您呈现最劲爆的塌房实锤。',
  },
  'heiliao-chigua': {
    name: '黑料吃瓜',
    subtitle: '深扒不为人知的真相',
    description: '深度挖掘娱乐圈与网红圈的黑料内幕，用事实说话，带你吃最真的瓜。',
  },
  'chigua-baoliao': {
    name: '吃瓜爆料',
    subtitle: '最新鲜的一手爆料',
    description: '汇集全网最新鲜的吃瓜爆料信息，匿名投稿、内部消息，让你抢先吃到第一口瓜。',
  },
  'meiri-dasai': {
    name: '每日大赛',
    subtitle: '每天都有新大瓜',
    description: '每日精选当天最火爆的吃瓜事件，热门排行实时更新，不错过任何一个大瓜。',
  },
  '51-chigua': {
    name: '51吃瓜入口',
    subtitle: '一站式吃瓜通道',
    description: '51吃瓜网站官方入口聚合页，覆盖51吃瓜在线观看、51吃瓜视频、51吃瓜官网等热门通道。',
  },
  'hot': {
    name: '热门排行',
    subtitle: '最火爆的吃瓜内容',
    description: '根据实时热度排序的吃瓜内容排行榜，看看大家都在关注什么大瓜。',
  },
};

export const categoryArticles: Record<string, ArticleItem[]> = {
  'wanghong-tafang': [
    {
      id: 101,
      slug: 'wanghong-a-fangche-shijian',
      title: '某千万粉网红被实锤假慈善，背后金主身份曝光引全网哗然',
      category: '网红塌房',
      categorySlug: 'wanghong-tafang',
      heat: '98.7万',
      heatNum: 987000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20scene%20of%20spotlight%20on%20empty%20stage%20with%20scattered%20papers%2C%20dramatic%20crimson%20red%20lighting%2C%20scandal%20and%20exposure%20mood%2C%20editorial%20photography%20with%20high%20contrast%20shadows%2C%20warm%20dark%20red%20and%20black%20tones%2C%20grainy%20cinematic%20texture%2C%20simple%20minimal%20background%2C%20professional%20composition&width=800&height=600&seq=cat-wt-01&orientation=landscape',
      time: '2小时前',
      summary: '曾经标榜公益人设的千万粉网红，被内部人士爆料所有慈善项目均为作秀，背后更有神秘资本运作。',
    },
    {
      id: 103,
      slug: 'ouxiang-lianai-baoguang',
      title: '顶流男偶像隐婚生子被拍，工作室紧急公关删帖反被扒出更多实锤',
      category: '网红塌房',
      categorySlug: 'wanghong-tafang',
      heat: '75.2万',
      heatNum: 752000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20paparazzi%20style%20night%20scene%2C%20shadowy%20figure%20with%20child%2C%20dramatic%20crimson%20backlight%2C%20mysterious%20noir%20cinematography%2C%20warm%20dark%20red%20tones%20with%20golden%20accents%2C%20grainy%20film%20grain%20texture%2C%20simple%20dark%20gradient%20background%2C%20editorial%20composition&width=800&height=600&seq=cat-wt-02&orientation=landscape',
      time: '8小时前',
      summary: '一向以单身人设圈粉的顶流男星，被狗仔拍到深夜带娃出街，粉丝集体破防。',
    },
    {
      id: 201,
      slug: 'wanghong-b-gongguan-weiji',
      title: '百万粉美妆博主抄袭事件升级：原创者发律师函，品牌方集体解约',
      category: '网红塌房',
      categorySlug: 'wanghong-tafang',
      heat: '54.3万',
      heatNum: 543000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20beauty%20studio%20scene%20in%20disarray%2C%20scattered%20cosmetics%20and%20mirrors%2C%20dramatic%20crimson%20side%20lighting%2C%20scandal%20and%20betrayal%20atmosphere%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-wt-03&orientation=landscape',
      time: '3小时前',
      summary: '该美妆博主被扒出多期视频内容抄袭海外博主，原创者已委托律师发函维权。',
    },
    {
      id: 202,
      slug: 'heike-wanghong-zhapian',
      title: '又一个带货网红翻车：被指售卖假冒保健品，受害者已超千人',
      category: '网红塌房',
      categorySlug: 'wanghong-tafang',
      heat: '48.1万',
      heatNum: 481000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20scattered%20supplement%20bottles%20on%20floor%2C%20crimson%20warning%20light%2C%20consumer%20fraud%20concept%2C%20editorial%20photography%20with%20high%20contrast%20shadows%2C%20warm%20dark%20red%20and%20black%20tones%2C%20grainy%20cinematic%20look%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-wt-04&orientation=landscape',
      time: '6小时前',
      summary: '消费者集体维权，该网红直播间售卖的保健品被检测出含有违禁成分。',
    },
    {
      id: 203,
      slug: 'zhibo-shi-gu',
      title: '户外主播直播中发生意外致人受伤，平台紧急关闭直播间',
      category: '网红塌房',
      categorySlug: 'wanghong-tafang',
      heat: '42.6万',
      heatNum: 426000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20outdoor%20scene%20at%20night%2C%20fallen%20tripod%20and%20equipment%2C%20dramatic%20crimson%20emergency%20lighting%2C%20accident%20and%20disruption%20mood%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20background%2C%20professional%20composition&width=800&height=600&seq=cat-wt-05&orientation=landscape',
      time: '10小时前',
      summary: '该主播为博眼球在闹市区进行危险直播，导致路人受伤，引发社会广泛关注。',
    },
    {
      id: 204,
      slug: 'wanghong-c-yinsi-xielou',
      title: '知名情侣网红分手互撕，双方放出大量私密聊天记录',
      category: '网红塌房',
      categorySlug: 'wanghong-tafang',
      heat: '38.9万',
      heatNum: 389000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20emotional%20scene%20with%20torn%20photographs%20on%20floor%2C%20dramatic%20crimson%20and%20black%20split%20lighting%2C%20relationship%20breakdown%20mood%2C%20editorial%20photography%20with%20high%20contrast%20shadows%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-wt-06&orientation=landscape',
      time: '1天前',
      summary: '曾经甜蜜的情侣网红突然宣布分手，双方在社交平台互爆黑料，聊天记录尺度惊人。',
    },
  ],
  'heiliao-chigua': [
    {
      id: 102,
      slug: 'daihuo-yijie-bengpan',
      title: '直播带货一姐偷税案后续：补缴金额高达数亿，团队核心成员被带走',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '86.3万',
      heatNum: 863000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20luxury%20items%20scattered%20on%20floor%2C%20dramatic%20crimson%20lighting%20from%20above%2C%20fallen%20crown%20symbolism%2C%20editorial%20fashion%20photography%20style%2C%20warm%20dark%20red%20and%20black%20tones%2C%20high%20contrast%2C%20grainy%20atmosphere%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-hl-01&orientation=landscape',
      time: '5小时前',
      summary: '继上次被罚后，更多偷税细节浮出水面，团队多名核心成员已被警方带走调查。',
    },
    {
      id: 104,
      slug: 'duan-shipin-dajiang',
      title: '短视频平台头部主播因言论不当被全网封杀，千万账号一夜归零',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '69.8万',
      heatNum: 698000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20with%20shattered%20phone%20screen%20displaying%20error%20message%2C%20dramatic%20crimson%20and%20black%20lighting%2C%20symbolic%20imagery%20of%20digital%20downfall%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-hl-02&orientation=landscape',
      time: '12小时前',
      summary: '该主播在直播中发表极端言论引发众怒，平台连夜出手全面封禁其所有账号。',
    },
    {
      id: 301,
      slug: 'yule-quan-neimu',
      title: '娱乐圈大佬性骚扰丑闻爆发：多名女艺人实名举报，警方已介入',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '92.5万',
      heatNum: 925000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20spotlight%20on%20empty%20director%20chair%2C%20crimson%20red%20emergency%20lighting%2C%20serious%20allegation%20concept%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20and%20black%20tones%2C%20grainy%20cinematic%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-hl-03&orientation=landscape',
      time: '4小时前',
      summary: '多名女艺人联合实名举报某知名导演长期性骚扰行为，警方表示已立案调查。',
    },
    {
      id: 302,
      slug: 'ziben-jiaoyi-jiemi',
      title: '某MCN机构黑幕曝光：通过数据造假骗取投资超五千万',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '66.2万',
      heatNum: 662000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20corporate%20scene%20with%20scattered%20documents%20and%20money%2C%20dramatic%20crimson%20backlight%2C%20fraud%20and%20deception%20theme%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-hl-04&orientation=landscape',
      time: '9小时前',
      summary: '前员工爆料该MCN机构通过刷量、买粉等手段虚报数据，骗取数千万风险投资。',
    },
    {
      id: 303,
      slug: 'mingxing-jiehun-neimu',
      title: '某知名女星婚姻危机：老公被拍到深夜与神秘女子进出酒店',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '58.7万',
      heatNum: 587000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20hotel%20corridor%20scene%20at%20night%2C%20shadowy%20figures%2C%20dramatic%20crimson%20neon%20light%2C%20infidelity%20suspicion%20mood%2C%20editorial%20paparazzi%20style%20photography%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20background%2C%20professional%20composition&width=800&height=600&seq=cat-hl-05&orientation=landscape',
      time: '7小时前',
      summary: '狗仔拍到该女星丈夫深夜与神秘女子同进酒店，三小时后才离开，引发婚变猜测。',
    },
    {
      id: 304,
      slug: 'fang-chan-jie-mu-heimu',
      title: '知名选秀节目被曝内定冠军：选手本人聊天记录意外流出',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '51.3万',
      heatNum: 513000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20stage%20with%20fallen%20microphone%20and%20trophy%2C%20crimson%20spotlight%2C%20competition%20scandal%20concept%2C%20editorial%20photography%20with%20high%20contrast%20shadows%2C%20warm%20dark%20red%20and%20black%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-hl-06&orientation=landscape',
      time: '11小时前',
      summary: '选手本人手机聊天记录意外泄露，显示节目组早在海选阶段就已确定最终排名。',
    },
  ],
  'chigua-baoliao': [
    {
      id: 105,
      slug: 'meishi-bozhu-fanshui',
      title: '知名美食博主被曝收钱做虚假测评，多家品牌连夜解约索赔',
      category: '吃瓜爆料',
      categorySlug: 'chigua-baoliao',
      heat: '63.5万',
      heatNum: 635000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20studio%20kitchen%20scene%20in%20disarray%2C%20dramatic%20crimson%20spotlight%20from%20side%2C%20mysterious%20mood%2C%20editorial%20food%20photography%20gone%20wrong%2C%20warm%20dark%20red%20and%20black%20tones%2C%20high%20contrast%20cinematic%20lighting%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-cb-01&orientation=landscape',
      time: '1天前',
      summary: '收钱黑竞品的聊天记录被曝光，涉及金额惊人，多家品牌宣布终止合作。',
    },
    {
      id: 401,
      slug: 'youxi-bozhu-xidu',
      title: '匿名爆料：某游戏区顶流主播疑似吸毒，直播中多次出现异常状态',
      category: '吃瓜爆料',
      categorySlug: 'chigua-baoliao',
      heat: '73.8万',
      heatNum: 738000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20disturbing%20gaming%20setup%20scene%2C%20flickering%20monitor%20with%20error%20screen%2C%20dramatic%20crimson%20warning%20light%2C%20danger%20and%20concern%20mood%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-cb-02&orientation=landscape',
      time: '3小时前',
      summary: '多名观众发现该主播直播时精神状态异常，知情人士匿名爆料称其常年吸毒。',
    },
    {
      id: 402,
      slug: 'baoxian-wanghong-tuixiu',
      title: '爆料：某保险网红自导自演车祸骗保，金额高达百万',
      category: '吃瓜爆料',
      categorySlug: 'chigua-baoliao',
      heat: '45.6万',
      heatNum: 456000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20damaged%20car%20at%20night%2C%20dramatic%20crimson%20police%20light%2C%20insurance%20fraud%20concept%2C%20editorial%20photography%20with%20high%20contrast%20shadows%2C%20warm%20dark%20red%20and%20black%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-cb-03&orientation=landscape',
      time: '6小时前',
      summary: '内部人士爆料该网红精心策划了多起车祸事故，累计骗取保险理赔金超百万。',
    },
    {
      id: 403,
      slug: 'zhuanti-jiafang-neimu',
      title: '爆料：某知识付费博主课程全是洗稿，原作者集体维权',
      category: '吃瓜爆料',
      categorySlug: 'chigua-baoliao',
      heat: '41.2万',
      heatNum: 412000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20scattered%20books%20and%20papers%2C%20crimson%20spotlight%2C%20plagiarism%20scandal%20theme%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20tones%2C%20grainy%20cinematic%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-cb-04&orientation=landscape',
      time: '14小时前',
      summary: '该博主标价上千元的课程内容被指几乎全文照搬多本畅销书，原作者们准备联合起诉。',
    },
    {
      id: 404,
      slug: 'siyu-zhibo-neimu',
      title: '爆料：某私域直播大佬利用虚拟人设圈钱，单场收入超千万',
      category: '吃瓜爆料',
      categorySlug: 'chigua-baoliao',
      heat: '55.9万',
      heatNum: 559000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20with%20holographic%20figure%20and%20money%20scattered%2C%20dramatic%20crimson%20lighting%2C%20digital%20deception%20theme%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20and%20black%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-cb-05&orientation=landscape',
      time: '2天前',
      summary: '该主播使用AI换脸和虚拟人设进行直播带货，粉丝打赏加购物金额单场破千万。',
    },
    {
      id: 405,
      slug: 'wanghong-shui-jun',
      title: '爆料：某头部MCN旗下所有网红统一购买水军刷数据',
      category: '吃瓜爆料',
      categorySlug: 'chigua-baoliao',
      heat: '36.4万',
      heatNum: 364000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20robotic%20hands%20on%20keyboards%2C%20crimson%20red%20glow%2C%20fake%20engagement%20concept%2C%20editorial%20photography%20with%20high%20contrast%20shadows%2C%20warm%20dark%20red%20and%20black%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=cat-cb-06&orientation=landscape',
      time: '18小时前',
      summary: '离职员工匿名爆料，该MCN机构为旗下所有签约网红统一采购了水军套餐。',
    },
  ],
  'meiri-dasai': [
    {
      id: 101,
      slug: 'wanghong-a-fangche-shijian',
      title: '某千万粉网红被实锤假慈善，背后金主身份曝光引全网哗然',
      category: '网红塌房',
      categorySlug: 'wanghong-tafang',
      heat: '98.7万',
      heatNum: 987000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20stage%20with%20dramatic%20red%20and%20crimson%20spotlight%2C%20silhouette%20of%20a%20person%20on%20stage%20facing%20away%2C%20scandal%20and%20exposure%20vibe%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20tones%2C%20cinematic%20mood%2C%20grainy%20texture%2C%20simple%20background%20with%20subtle%20red%20gradient&width=800&height=600&seq=md-01&orientation=landscape',
      time: '2小时前',
      summary: '曾经标榜公益人设的千万粉网红，被内部人士爆料所有慈善项目均为作秀。',
    },
    {
      id: 301,
      slug: 'yule-quan-neimu',
      title: '娱乐圈大佬性骚扰丑闻爆发：多名女艺人实名举报，警方已介入',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '92.5万',
      heatNum: 925000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20spotlight%20on%20empty%20director%20chair%2C%20crimson%20red%20emergency%20lighting%2C%20serious%20allegation%20concept%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20and%20black%20tones%2C%20grainy%20cinematic%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=md-02&orientation=landscape',
      time: '4小时前',
      summary: '多名女艺人联合实名举报某知名导演长期性骚扰行为，警方表示已立案调查。',
    },
    {
      id: 102,
      slug: 'daihuo-yijie-bengpan',
      title: '直播带货一姐偷税案后续：补缴金额高达数亿，团队核心成员被带走',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '86.3万',
      heatNum: 863000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20luxury%20items%20scattered%20on%20floor%2C%20dramatic%20crimson%20lighting%20from%20above%2C%20fallen%20crown%20symbolism%2C%20editorial%20photography%20style%2C%20warm%20dark%20red%20and%20black%20tones%2C%20high%20contrast%2C%20grainy%20atmosphere%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=md-03&orientation=landscape',
      time: '5小时前',
      summary: '继上次被罚后，更多偷税细节浮出水面，团队多名核心成员已被警方带走调查。',
    },
    {
      id: 401,
      slug: 'youxi-bozhu-xidu',
      title: '匿名爆料：某游戏区顶流主播疑似吸毒，直播中多次出现异常状态',
      category: '吃瓜爆料',
      categorySlug: 'chigua-baoliao',
      heat: '73.8万',
      heatNum: 738000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20disturbing%20gaming%20setup%20scene%2C%20flickering%20monitor%20with%20error%20screen%2C%20dramatic%20crimson%20warning%20light%2C%20danger%20and%20concern%20mood%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=md-04&orientation=landscape',
      time: '3小时前',
      summary: '多名观众发现该主播直播时精神状态异常，知情人士匿名爆料称其常年吸毒。',
    },
    {
      id: 103,
      slug: 'ouxiang-lianai-baoguang',
      title: '顶流男偶像隐婚生子被拍，工作室紧急公关删帖反被扒出更多实锤',
      category: '网红塌房',
      categorySlug: 'wanghong-tafang',
      heat: '75.2万',
      heatNum: 752000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20paparazzi%20style%20scene%2C%20shadowy%20figure%20walking%20away%2C%20dramatic%20red%20and%20amber%20backlight%2C%20cinematic%20noir%20photography%2C%20warm%20dark%20tones%2C%20grainy%20texture%2C%20simple%20dark%20gradient%20background%2C%20editorial%20composition&width=800&height=600&seq=md-05&orientation=landscape',
      time: '8小时前',
      summary: '一向以单身人设圈粉的顶流男星，被狗仔拍到深夜带娃出街，粉丝集体破防。',
    },
    {
      id: 104,
      slug: 'duan-shipin-dajiang',
      title: '短视频平台头部主播因言论不当被全网封杀，千万账号一夜归零',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '69.8万',
      heatNum: 698000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20with%20shattered%20phone%20screen%2C%20dramatic%20crimson%20and%20black%20lighting%2C%20symbolic%20digital%20downfall%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=md-06&orientation=landscape',
      time: '12小时前',
      summary: '该主播在直播中发表极端言论引发众怒，平台连夜出手全面封禁其所有账号。',
    },
  ],
  '51-chigua': [
    {
      id: 102,
      slug: 'daihuo-yijie-bengpan',
      title: '直播带货一姐偷税案后续：补缴金额高达数亿，团队核心成员被带走',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '86.3万',
      heatNum: 863000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20luxury%20items%20scattered%20on%20floor%2C%20dramatic%20crimson%20lighting%2C%20fallen%20crown%2C%20editorial%20photography%20style%2C%20warm%20dark%20red%20and%20black%20tones%2C%20high%20contrast%2C%20grainy%20atmosphere%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=51cg-01&orientation=landscape',
      time: '5小时前',
      summary: '继上次被罚后，更多偷税细节浮出水面，团队多名核心成员已被警方带走调查。',
    },
    {
      id: 101,
      slug: 'wanghong-a-fangche-shijian',
      title: '某千万粉网红被实锤假慈善，背后金主身份曝光引全网哗然',
      category: '网红塌房',
      categorySlug: 'wanghong-tafang',
      heat: '98.7万',
      heatNum: 987000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20stage%20with%20dramatic%20crimson%20spotlight%2C%20silhouette%20of%20person%20on%20stage%2C%20scandal%20vibe%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20tones%2C%20cinematic%20mood%2C%20grainy%20texture%2C%20simple%20background%20with%20red%20gradient&width=800&height=600&seq=51cg-02&orientation=landscape',
      time: '2小时前',
      summary: '曾经标榜公益人设的千万粉网红，被内部人士爆料所有慈善项目均为作秀。',
    },
    {
      id: 301,
      slug: 'yule-quan-neimu',
      title: '娱乐圈大佬性骚扰丑闻爆发：多名女艺人实名举报，警方已介入',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '92.5万',
      heatNum: 925000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20spotlight%20on%20empty%20director%20chair%2C%20crimson%20emergency%20lighting%2C%20serious%20allegation%20concept%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20and%20black%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=51cg-03&orientation=landscape',
      time: '4小时前',
      summary: '多名女艺人联合实名举报某知名导演长期性骚扰行为，警方表示已立案调查。',
    },
    {
      id: 401,
      slug: 'youxi-bozhu-xidu',
      title: '匿名爆料：某游戏区顶流主播疑似吸毒，直播中多次出现异常状态',
      category: '吃瓜爆料',
      categorySlug: 'chigua-baoliao',
      heat: '73.8万',
      heatNum: 738000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20disturbing%20gaming%20setup%20scene%2C%20flickering%20monitor%2C%20dramatic%20crimson%20warning%20light%2C%20danger%20mood%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20background%2C%20professional%20composition&width=800&height=600&seq=51cg-04&orientation=landscape',
      time: '3小时前',
      summary: '多名观众发现该主播直播时精神状态异常，知情人士匿名爆料称其常年吸毒。',
    },
  ],
  'hot': [
    {
      id: 301,
      slug: 'yule-quan-neimu',
      title: '娱乐圈大佬性骚扰丑闻爆发：多名女艺人实名举报，警方已介入',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '92.5万',
      heatNum: 925000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20scene%20of%20spotlight%20on%20empty%20director%20chair%2C%20crimson%20red%20emergency%20lighting%2C%20serious%20allegation%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20and%20black%20tones%2C%20grainy%20cinematic%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=hot-01&orientation=landscape',
      time: '4小时前',
      summary: '多名女艺人联合实名举报某知名导演长期性骚扰行为，警方表示已立案调查。',
    },
    {
      id: 101,
      slug: 'wanghong-a-fangche-shijian',
      title: '某千万粉网红被实锤假慈善，背后金主身份曝光引全网哗然',
      category: '网红塌房',
      categorySlug: 'wanghong-tafang',
      heat: '98.7万',
      heatNum: 987000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20stage%20with%20dramatic%20crimson%20spotlight%2C%20silhouette%20of%20person%20facing%20away%2C%20scandal%20vibe%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20tones%2C%20cinematic%20mood%2C%20grainy%20texture%2C%20simple%20background%20with%20red%20gradient&width=800&height=600&seq=hot-02&orientation=landscape',
      time: '2小时前',
      summary: '曾经标榜公益人设的千万粉网红，被内部人士爆料所有慈善项目均为作秀。',
    },
    {
      id: 102,
      slug: 'daihuo-yijie-bengpan',
      title: '直播带货一姐偷税案后续：补缴金额高达数亿，团队核心成员被带走',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '86.3万',
      heatNum: 863000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20of%20luxury%20items%20scattered%20on%20floor%2C%20dramatic%20crimson%20lighting%20from%20above%2C%20fallen%20crown%20symbolism%2C%20editorial%20photography%20style%2C%20warm%20dark%20red%20and%20black%20tones%2C%20high%20contrast%2C%20grainy%20atmosphere%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=hot-03&orientation=landscape',
      time: '5小时前',
      summary: '继上次被罚后，更多偷税细节浮出水面，团队多名核心成员已被警方带走调查。',
    },
    {
      id: 401,
      slug: 'youxi-bozhu-xidu',
      title: '匿名爆料：某游戏区顶流主播疑似吸毒，直播中多次出现异常状态',
      category: '吃瓜爆料',
      categorySlug: 'chigua-baoliao',
      heat: '73.8万',
      heatNum: 738000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20disturbing%20gaming%20setup%20scene%2C%20flickering%20monitor%20with%20error%2C%20dramatic%20crimson%20warning%20light%2C%20danger%20mood%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=hot-04&orientation=landscape',
      time: '3小时前',
      summary: '多名观众发现该主播直播时精神状态异常，知情人士匿名爆料称其常年吸毒。',
    },
    {
      id: 103,
      slug: 'ouxiang-lianai-baoguang',
      title: '顶流男偶像隐婚生子被拍，工作室紧急公关删帖反被扒出更多实锤',
      category: '网红塌房',
      categorySlug: 'wanghong-tafang',
      heat: '75.2万',
      heatNum: 752000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20paparazzi%20style%20scene%2C%20shadowy%20figure%20walking%20away%2C%20dramatic%20red%20and%20amber%20backlight%2C%20cinematic%20noir%20photography%2C%20warm%20dark%20tones%2C%20grainy%20texture%2C%20simple%20dark%20gradient%20background%2C%20editorial%20composition&width=800&height=600&seq=hot-05&orientation=landscape',
      time: '8小时前',
      summary: '一向以单身人设圈粉的顶流男星，被狗仔拍到深夜带娃出街，粉丝集体破防。',
    },
    {
      id: 104,
      slug: 'duan-shipin-dajiang',
      title: '短视频平台头部主播因言论不当被全网封杀，千万账号一夜归零',
      category: '黑料吃瓜',
      categorySlug: 'heiliao-chigua',
      heat: '69.8万',
      heatNum: 698000,
      image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20scene%20with%20shattered%20phone%20screen%2C%20dramatic%20crimson%20and%20black%20lighting%2C%20symbolic%20digital%20downfall%2C%20editorial%20photography%20with%20high%20contrast%2C%20warm%20dark%20red%20tones%2C%20grainy%20texture%2C%20simple%20gradient%20background%2C%20professional%20composition&width=800&height=600&seq=hot-06&orientation=landscape',
      time: '12小时前',
      summary: '该主播在直播中发表极端言论引发众怒，平台连夜出手全面封禁其所有账号。',
    },
  ],
};

export const defaultCategoryArticles: ArticleItem[] = categoryArticles['wanghong-tafang'];